import {styled} from '@linaria/react';
import React from 'react';
import {FONT_SIZES, FONT_WEIGHTS} from '../../../constants/typography';
import type {Entry} from '../../../types/Entry';
import type {ImageType} from '../../../types/Image';
import {Image} from '../../atoms/Image/Image';
import {RichText} from '../../atoms/Text/RichText';
import {Text} from '../../atoms/Text/Text';
import {UnstyledLinkLinaria} from '../../atoms/UnstyledLink/UnstyledLinkLinaria';

type LinkEntry = Entry & {
  image?: ImageType;
};

interface LinksSectionProps {
  className?: string;
  links: LinkEntry[];
  heading: string;
  testId?: string;
}

export const LinksSection: React.FC<LinksSectionProps> = ({
  links,
  heading,
  testId,
  ...props
}) => {
  return (
    <Wrapper data-testid={testId || 'linksSection'} {...props}>
      <Heading size="px12">{heading}</Heading>
      {links.map((item, index) => (
        <LinkItem link={item} key={index} />
      ))}
    </Wrapper>
  );
};

const LinkItem: React.FC<{link: LinkEntry}> = ({link}) => {
  return (
    <ItemWrapper to={link.href} aria-label={undefined}>
      {link.image ? (
        <StyledImage
          src={link.image.url}
          alt={link.image.description}
          breakpoints={[]}
          ratio={'1:1'}
          widths={[75]}
          loading="lazy"
          importance="low"
        />
      ) : null}
      <RichText>{link.label}</RichText>
    </ItemWrapper>
  );
};

const Heading = styled(Text)`
  text-transform: uppercase;
  font-weight: ${FONT_WEIGHTS.bold};
  margin-bottom: 2rem;
  display: block;
`;

const Wrapper = styled.div`
  padding: 1.5rem;
`;

const ItemWrapper = styled(UnstyledLinkLinaria)`
  display: flex;
  align-items: center;
  margin-bottom: 1rem;

  span {
    display: inline-block;
    font-size: ${FONT_SIZES.px14};
    font-weight: ${FONT_WEIGHTS.mediumBold};
  }
`;

const StyledImage = styled(Image)`
  width: 24px;
  height: 24px;
  margin-right: 0.5rem;
  filter: grayscale(1);
  mix-blend-mode: darken;
`;
